import { render } from "./NavBadge.vue?vue&type=template&id=a7f0d886&scoped=true"
import script from "./NavBadge.vue?vue&type=script&lang=js"
export * from "./NavBadge.vue?vue&type=script&lang=js"

import "./NavBadge.vue?vue&type=style&index=0&id=a7f0d886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f0d886"]])

export default __exports__